import { ActionReducer } from '@ngrx/store';

import { ClearLocalStorage } from '../../local-storage/helpers/clear-local-storage.helper';
import { AuthenticationActionTypes } from './authentication.actions';

export function clearState(reducer: ActionReducer<any>): ActionReducer<any> {
    return (state, action) => {
        if (action.type === AuthenticationActionTypes.Logout) {
            state = undefined;
            ClearLocalStorage();
        }

        return reducer(state, action);
    };
}
